import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  image: 'https://i.postimg.cc/DZ47sqqg/download-(1)-min.png',
  alt: 'Testimonio 1'
}, {
  image: 'https://i.postimg.cc/7ZPDXv37/download-(2)-min.png',
  alt: 'Testimonio 2'
}];
export function TestimonialsSection() {
  return <section className="w-full py-24 px-6 bg-[#050505]" data-id="element-142">
      <div className="max-w-3xl mx-auto space-y-12" data-id="element-143">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-[#f0f0f0] text-center" data-id="element-144">
          Lo que dicen quienes ya lo usaron
        </motion.h2>

        <div className="space-y-8" data-id="element-145">
          {testimonials.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="bg-[#0a0f0d] border border-gray-800 rounded-xl overflow-hidden shadow-lg" data-id="element-146">
              <img src={item.image} alt={item.alt} className="w-full h-auto object-contain" data-id="element-147" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}